export default "__VITE_ASSET__f4f82394__"